@if (mode === 'dropdown') {
    <button
        type="button"
        mat-icon-button
        class="language-menu-trigger"
        [attr.aria-label]="'shared.languageToggle.language' | transloco"
        [matMenuTriggerFor]="languageMenu"
    >
        <mat-icon>language</mat-icon>
    </button>

    <mat-menu #languageMenu="matMenu">
        @for (opt of langOptions; track opt.id) {
            <button
                type="button"
                mat-menu-item
                class="language-menu-item"
                [class.language-menu-item--active]="isActive(opt.id)"
                (click)="setLang(opt.id)"
            >
                <span class="language-menu-item-text">
                    <img class="language-menu-flag" [src]="opt.flagUrl" alt="" width="23" height="15" />
                    <span class="language-menu-label">{{ opt.label }}</span>
                </span>
            </button>
        }
    </mat-menu>
} @else {
    <div class="language-toggle-flags" [attr.aria-label]="'shared.languageToggle.language' | transloco" role="group">
        @for (opt of langOptions; track opt.id) {
            <button
                type="button"
                class="flag-circle"
                [class.flag-circle--active]="isActive(opt.id)"
                [class.flag-circle--grayscale]="!isActive(opt.id)"
                [attr.aria-label]="opt.label"
                [attr.aria-pressed]="isActive(opt.id)"
                (click)="setLang(opt.id)"
            >
                <span class="flag-circle__label">{{ opt.shortLabel }}</span>
            </button>
        }
    </div>
}
